import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import pl from "./locales/pl.json";
import it from "./locales/it.json";
import ru from "./locales/ru.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import tr from "./locales/tr.json";
import zh from "./locales/zh.json";
import th from "./locales/th.json";
import sv from "./locales/sv.json";
import no from "./locales/no.json";
import nl from "./locales/nl.json";
import da from "./locales/da.json";
import cs from "./locales/cs.json";
import id from "./locales/id.json";
import vi from "./locales/vi.json";
import uk from "./locales/uk.json";

export const resources = {
  en,
  es,
  pt,
  fr,
  de,
  pl,
  it,
  ru,
  ja,
  ko,
  tr,
  zh,
  th,
  sv,
  no,
  nl,
  da,
  cs,
  id,
  vi,
  uk,
} as const;

export const supportedLngs = Object.keys(resources);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs,
    fallbackLng: "en",
    // Wix passes the user's locale via the `lang` query param on the dashboard
    // iframe URL; fall back to the browser/navigator language otherwise.
    detection: {
      order: ["querystring", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
    // Map regional codes (e.g. pt-BR, zh-Hant) down to our base languages.
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    returnNull: false,
  });

export default i18n;
